import { useCallback, useEffect } from 'react';

import {
  AddBox,
  ArrowSelectorTool,
  Comment,
  FactCheck,
  FindInPage,
  useUnleash,
} from '@/package';
import {
  type ToolMenuItem,
  useLabelingBoxStore,
  useReviewStore,
  useTaskFrameStore,
  useToolMenuStore,
} from '@/store';

import LabelingSelectPopup from './LabelingSelectPopup';
import ToolbarGroup from './ToolbarGroup';
import ToolbarMenu from './ToolbarMenu';

const WorkingToolbarGroup = () => {
  const { isEnabled } = useUnleash();
  const isToolListInitialized = useToolMenuStore(
    state => state.isToolListInitialized,
  );
  const toolMap = useToolMenuStore(state => state.toolMap);
  const selectedBoxIdMap = useLabelingBoxStore(state => state.selectedBoxIdMap);

  const isDone = useTaskFrameStore.getState().isWorkState('Done');
  const isNotStarted = useTaskFrameStore.getState().isWorkState('Prework');

  const onToolbarClick = useCallback((toolMenuItem?: Nullish<ToolMenuItem>) => {
    if (!toolMenuItem) return;

    useToolMenuStore.getState().select(toolMenuItem.id);
  }, []);

  useEffect(() => {
    const isSelectedByToolName =
      useToolMenuStore.getState().isSelectedByToolName;

    useReviewStore
      .getState()
      .setReviewCommentVisible(isSelectedByToolName('reviewData'));
    useReviewStore
      .getState()
      .setReviewBoxMode(isSelectedByToolName('reviewData'));
  }, [toolMap]);

  useEffect(() => {
    if (Object.keys(selectedBoxIdMap).length > 0) {
      onToolbarClick(useToolMenuStore.getState().findByName('select'));
    }
  }, [selectedBoxIdMap, toolMap]);

  return (
    <ToolbarGroup className="relative z-10" visibleDivider>
      <ToolbarMenu
        className="size-9"
        toolMenuItem={useToolMenuStore.getState().findByName('select')}
        onClick={onToolbarClick}
      >
        <ArrowSelectorTool />
      </ToolbarMenu>

      <ToolbarMenu
        className="size-9"
        disabled={isDone || isNotStarted || !isToolListInitialized}
        toolMenuItem={useToolMenuStore.getState().findByName('box')}
        onClick={toolMenuItem => {
          useLabelingBoxStore.getState().clearSelectBoxList();

          onToolbarClick(toolMenuItem);
        }}
      >
        <AddBox />
        <LabelingSelectPopup />
      </ToolbarMenu>

      {isEnabled('vuex.sapporo.enabledTrackIDManager') && (
        <ToolbarMenu
          className="size-9"
          disabled={isNotStarted}
          toolMenuItem={useToolMenuStore.getState().findByName('searchTrackID')}
          onClick={onToolbarClick}
        >
          <FindInPage />
        </ToolbarMenu>
      )}

      <ToolbarMenu
        className="size-9"
        disabled={isNotStarted}
        toolMenuItem={useToolMenuStore.getState().findByName('boxValidation')}
        onClick={onToolbarClick}
      >
        <FactCheck />
      </ToolbarMenu>

      <ToolbarMenu
        className="size-9"
        disabled={isNotStarted}
        toolMenuItem={useToolMenuStore.getState().findByName('reviewData')}
        onClick={onToolbarClick}
      >
        <Comment />
      </ToolbarMenu>
    </ToolbarGroup>
  );
};

export default WorkingToolbarGroup;
